import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const nav = useNavigate();

  const [isSignup, setIsSignup] = useState(false);

  const [form, setForm] = useState({
    name: "",
    mobile: "",
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // LOGIN
  const login = async () => {
    if (!form.email || !form.password) {
      alert("Enter email & password");
      return;
    }

    try {
      const res = await fetch("https://swiftintelli.com/api/login.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: form.email,
          password: form.password,
        }),
      });

      const data = await res.json();

      if (data.status === "success") {
        localStorage.setItem("user", JSON.stringify(data.user));
        nav("/home-settings");
      } else {
        alert(data.message || "Invalid login");
      }
    } catch {
      alert("Server error");
    }
  };

  // SIGNUP
  const signup = async () => {
    if (!form.name || !form.mobile || !form.email || !form.password) {
      alert("Please fill all fields");
      return;
    }

    try {
      const res = await fetch("https://swiftintelli.com/api/register.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();

      if (data.status === "success") {
        alert("Signup successful!");

        // clear form
        setForm({
          name: "",
          mobile: "",
          email: "",
          password: "",
        });

        setIsSignup(false);
      } else {
        alert(data.message || "Signup failed");
      }
    } catch {
      alert("Server error");
    }
  };

  // ✅ FORM SUBMIT HANDLER (FIX)
  const handleSubmit = (e) => {
    e.preventDefault();
    isSignup ? signup() : login();
  };

  return (
    <div className="container">
      {/* LEFT SIDE */}
      <div className="login-left">
        {/* ✅ FORM ADDED */}
        <form className="form-card" onSubmit={handleSubmit}>
          <h2>{isSignup ? "Create Account" : "Welcome Back"}</h2>
          <p>{isSignup ? "Sign up to continue" : "Login to continue"}</p>

          {/* SIGNUP FIELDS */}
          {isSignup && (
            <>
              <input
                name="name"
                placeholder="Full Name"
                value={form.name}
                onChange={handleChange}
              />

              <input
                name="mobile"
                placeholder="Mobile"
                value={form.mobile}
                onChange={handleChange}
              />
            </>
          )}

          {/* COMMON FIELDS */}
          <input
            name="email"
            placeholder="Email"
            value={form.email}
            onChange={handleChange}
          />

          <input
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
          />

          {/* ✅ SUBMIT BUTTON */}
          <button type="submit">{isSignup ? "Sign Up" : "Login"}</button>

          {/* TOGGLE */}
          <p className="switch-text">
            {isSignup ? "Already have account?" : "New user?"}
            <span onClick={() => setIsSignup(!isSignup)}>
              {isSignup ? " Login" : " Sign Up"}
            </span>
          </p>
        </form>
      </div>

      {/* RIGHT SIDE */}
      <div className="login-right">
        <div className="overlay">
          <h3>Welcome to Swiftintelli</h3>
          <p>Upgrade your skills faster 🚀</p>
        </div>
      </div>
    </div>
  );
}
